import type { ReactNode } from 'react';

interface CardProps {
  title?: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
}

export function Card({ title, description, children, footer }: CardProps) {
  return (
    <section
      style={{
        background: 'var(--color-card)',
        border: 'var(--border-default)',
        borderRadius: 'var(--radius-lg)',
        padding: '18px',
        marginBottom: '16px',
      }}
    >
      {(title ?? description) && (
        <header style={{ marginBottom: '14px' }}>
          {title && (
            <h2
              style={{
                margin: '0 0 4px',
                color: 'var(--color-text-primary)',
                fontSize: '13px',
                fontWeight: 500,
              }}
            >
              {title}
            </h2>
          )}
          {description && (
            <p
              style={{
                margin: 0,
                fontSize: '11px',
                color: 'var(--color-text-secondary)',
                lineHeight: 1.5,
              }}
            >
              {description}
            </p>
          )}
        </header>
      )}
      {children}
      {footer && (
        <footer
          style={{
            marginTop: '14px',
            paddingTop: '12px',
            borderTop: 'var(--border-default)',
          }}
        >
          {footer}
        </footer>
      )}
    </section>
  );
}
